import React from 'react';

/**
 * 导航菜单
 */
export default class  Link extends React.Component {
  render () {
    return (
      <a className={this.props.className} href={this.props.data.to} >
        {this.props.data.text}
      </a>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/Link.js